import { render, staticRenderFns } from "./OpleidingOverzicht.vue?vue&type=template&id=4abe024d&"
import script from "./OpleidingOverzicht.vue?vue&type=script&lang=js&"
export * from "./OpleidingOverzicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports